<ng-container *ngIf="!isDesktop; else desktopComponent">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="showSwipeUp"
    [showHeader]="true"
    [subTitle]="subtitle"
    [title]="'INSTALLMENTS_INFO.CARDS_TITLE' | transloco"
    (toggleShowSwipeUp)="closeModal.emit()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="cardPartnersTemplate"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopComponent>
  <ng-container *ngIf="showSwipeUp">
    <app-modal
      [width]="447"
      [showHeader]="true"
      [title]="'INSTALLMENTS_INFO.CARDS_TITLE' | transloco"
      [subTitle]="subtitle"
      (toggleModal)="closeModal.emit()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="cardPartnersTemplate"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>


<ng-template #cardPartnersTemplate>
  <div class="partnertsTable">
    <div class="partnertsTable__header">
      <div class="partnertsTable__col">
        <span>
          {{ 'INSTALLMENTS_INFO.CARDS' | transloco }}
        </span>
      </div>

      <ng-container *ngFor="let installment of enabledCardInstallments; index as position">
        <div class="partnertsTable__col" [class.box-shadow-light]="isDefaultCardInstallment(position)">
          <span>
            {{ buildAlternativeTextKey(position) }}
          </span>
        </div>
      </ng-container>
    </div>

    <div class="partnertsTable__body">
      <div class="partnertsTable__row-body" *ngFor="let item of cards">
        <div class="partnertsTable__row">
          {{ item.name }}
        </div>
        <ng-container *ngFor="let installment of installments(item.installments) | slice : 0 : maxItems; index as position">
          <div class="partnertsTable__row" [class.box-shadow-light]="isDefaultCardInstallment(position)">
            <i aria-hidden="true" [class]="installmentIcon(installment, position)"></i>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>